export const OKTA_AUTHENTICATED = 'OKTA_AUTHENTICATED';
export const OKTA_FETCH_USER = 'OKTA_FETCH_USER';
export const OKTA_IS_FETCHING = 'OKTA_IS_FETCHING'
export const OKTA_GROUPS = 'OKTA_GROUPS'

export const SET_SECTIONS = 'SET_SECTIONS'
export const SET_CONTRIBUTOR = 'SET_CONTRIBUTOR'

export const SHOW_MODAL = 'SHOW_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'